const allFields = [
    "spaceType",
    "homeName",
    "street",
    "houseNumber",
    "postalCode",
    "city",
    "country",
    "description",
    "guests",
    "bedrooms",
    "beds",
    "bathrooms",
    "rate"
  ];
  
  export default allFields;